const collator = new Intl.Collator("fr", { numeric: true, sensitivity: "base" });

/** Natural order of file names and ZIP paths: « 2.png » before « 10.png », case and accents ignored. */
export function naturalCompare(a: string, b: string): number {
  return collator.compare(a, b) || (a < b ? -1 : a > b ? 1 : 0);
}

/** Moves the item at `from` to `to` (both 0-based), returning a new array. */
export function move<T>(items: readonly T[], from: number, to: number): T[] {
  const copy = [...items];
  if (from < 0 || from >= copy.length || to < 0 || to >= copy.length) return copy;
  const [item] = copy.splice(from, 1);
  copy.splice(to, 0, item!);
  return copy;
}
